module.exports = __webpack_public_path__ + "assets/img/effect_(3).45260425.gif";